import PosterGalleryFrame from "./poster-gallery.component";

export default PosterGalleryFrame;
